import { defer, from, fromEventPattern, iif, merge, of, timer } from 'rxjs';
import { startWith, scan, map, shareReplay, filter, withLatestFrom, mergeMap, distinct, combineLatestWith, distinctUntilChanged, bufferToggle, throttleTime, switchMap, toArray, mergeWith, catchError, tap, delay, take, } from 'rxjs/operators';
import { EventEmitter } from 'events';
import lodashGet from 'lodash/get';
import { convertToPinyin } from 'tiny-pinyin';
import { api as masterApi } from '@/api/api';
import { apis } from '@/config';
const switchContact2IMUser = list => {
    const _switch = (contact) => {
        const contactInfo = contact.contactInfo.filter(item => item.contactItemType === 'yunxin')[0];
        return {
            avatar: contact.contact.avatar,
            account: contactInfo.contactItemVal,
            email: contact.contact.accountName,
            nick: contact.contact.contactName,
            pinyinname: contact.contact.contactPYName,
            color: contact.contact.color,
            status: contact.contact.accountStatus,
            tel: '',
            contactId: contact.contact.id,
        };
    };
    return list.filter(item => lodashGet(item, 'contactInfo.length', 0) !== 0 && lodashGet(item, 'contact.enableIM', true) !== false).map(item => _switch(item));
};
export class IM_Users {
    constructor() {
        this.sdk = null;
        this.subject = null;
        this.myEvent = new EventEmitter();
        this.contactApi = masterApi.requireLogicalApi(apis.contactApiImpl);
    }
    init(sdk) {
        this.sdk = sdk;
        const onusers = (handler) => {
            this.myEvent.on(IM_Users.Event_Names.onusers, handler);
        };
        const offusers = (handler) => {
            this.myEvent.off(IM_Users.Event_Names.onusers, handler);
        };
        this.subject = fromEventPattern(onusers, offusers).pipe(scan((total, current) => [...total, ...current], []), map(list => list.reduce((total, current) => {
            total = Object.assign(Object.assign({}, total), { [current.account]: current });
            return total;
        }, {})), startWith({}), shareReplay(1));
        const onrequest = (handler) => {
            this.myEvent.on(IM_Users.Event_Names.request, handler);
        };
        const offrequest = (handler) => {
            this.myEvent.off(IM_Users.Event_Names.request, handler);
        };
        const $event = fromEventPattern(onrequest, offrequest);
        const $eventBuffer = $event.pipe(throttleTime(50));
        $event
            .pipe(tap(val => {
            console.log('[im.users]request.item', val);
        }), bufferToggle($eventBuffer, () => timer(50)))
            .pipe(withLatestFrom(this.subject), map(([accounts, userMap]) => {
            console.log('im_user:', accounts);
            const _accounts = [...new Set(accounts)];
            const keys = Object.keys(userMap);
            return _accounts.filter(account => !keys.includes(account));
        }), mergeMap(accounts => {
            const contactAccounts = accounts.filter(item => item.indexOf('lx_') === -1).map(id => id.replace(/@\d+$/, ''));
            const yunxinAccounts = accounts.filter(item => item.indexOf('lx_') !== -1).map(id => id.replace(/@\d+$/, ''));
            return this._queryContactUsers(contactAccounts).pipe(mergeWith(this._queryYunxinUsers(yunxinAccounts)));
        }), map(users => users.map(item => {
            item.pinyin = convertToPinyin(item.nick, '-', true);
            return item;
        })), catchError(error => {
            console.log('[im.users]request.failed', error);
            return from(Promise.resolve([]));
        }))
            .subscribe(users => {
            console.log('[im.users]request.complete', users);
            this.myEvent.emit(IM_Users.Event_Names.onusers, users);
        });
    }
    _queryContactUsers(accounts) {
        return of(...accounts).pipe(toArray(), filter(arr => arr.filter(item => item.length > 0).length > 0), switchMap(ids => {
            const requestPromise = this.contactApi.doGetContactByYunxin(ids);
            return from(requestPromise);
        }), mergeMap(({ needRequestAccounts, contactModelList }) => iif(() => Array.isArray(needRequestAccounts) && needRequestAccounts.length > 0, merge(from(Promise.resolve(contactModelList)), from(this.contactApi.doGetServerContactByYunxin(needRequestAccounts))), from(Promise.resolve(contactModelList)))), map(users => switchContact2IMUser(users)));
    }
    _queryYunxinUsers(accounts) {
        return from(Promise.resolve(accounts)).pipe(filter(item => item.length > 0), switchMap(ids => {
            const $request = defer(() => {
                const request = this.sdk.excute('getUsers', {
                    accounts: ids,
                });
                return from(request);
            });
            return $request.pipe(catchError((err, caught) => {
                console.log('[im.users]request.yunxunaccounts.error', err);
                return caught.pipe(delay(2000), take(10));
            }));
        }));
    }
    getUserById($account) {
        return this.subject.pipe(combineLatestWith($account), map(([userMap, account]) => userMap[account]), distinctUntilChanged((prev, next) => ['account', 'nick', 'avatar'].every(field => lodashGet(prev, field, '') === lodashGet(next, field, ''))));
    }
    getUsersByIds($ids) {
        return this.subject.pipe(combineLatestWith(from($ids)), map(([users, accounts]) => accounts.filter(account => lodashGet(users, `${account}.nick.length`, 0) !== 0).map(item => users[item])), map(checkedUser => checkedUser.reduce((total, current) => (Object.assign(Object.assign({}, total), { [current.account]: current })), {})), distinctUntilChanged((prev, next) => Object.keys(prev || {}).join('-') === Object.keys(next || {}).join('-')));
    }
    getUserProp($id, $prop) {
        const $result = this.subject.pipe(combineLatestWith(from($id)), filter(([userMap, account]) => Reflect.has(userMap, account)), map(([userMap, account]) => userMap[account]), withLatestFrom($prop), distinct(([user, key]) => user[key]), map(([user, key]) => user[key]));
        return $result;
    }
    requestUser(account) {
        this.myEvent.emit(IM_Users.Event_Names.request, account);
    }
    getSubject() {
        return this.subject;
    }
}
IM_Users.Event_Names = {
    onusers: 'onusers',
    request: 'request',
};
